import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="empty">
      <div className="empty-header">404</div>
      <p className="empty-title">Page not found</p>
      <p className="empty-subtitle text-muted">
        Đường dẫn không tồn tại trong dashboard này.
      </p>
      <div className="empty-action">
        <Button as={Link} to="/categories">
          Go to Categories
        </Button>
      </div>
    </div>
  );
}

